import {showCommunicationError, showNotFoundToast, showSuccess} from 'helpers/alerts';
import {t} from 'i18next';
import {action, makeObservable, observable, runInAction} from 'mobx';
import {redirectTo} from 'routing/browserHistory';
import {AppRoutePaths} from 'routing/Routes';
import {AddressDto, CustomerDto} from '../../../../../../PRMGApiClient';
import {Api} from '../../../../../../PRMGApiClient/ApiClient';
import {appState} from '../../AppStore';

export class CustomerState {
  @observable
  item: CustomerDto = {
    customerId: undefined,
    email: undefined,
    additionalEmail: undefined,
    phone: undefined,
    additionalPhone: undefined,
    firstName: undefined,
    lastName: undefined,
    isCompany: false,
    nip: undefined,
    companyName: undefined,
    fkId: undefined,
    applicationUserId: undefined,
    billAddress: <AddressDto>{
      addressId: undefined,
      city: undefined,
      streetWithLocal: undefined,
      street: undefined,
      buildingNumber: undefined,
      apartmentNumber: undefined,
      postalCode: undefined,
    },
    correspondenceAddress: <AddressDto>{
      addressId: undefined,
      city: undefined,
      streetWithLocal: undefined,
      street: undefined,
      buildingNumber: undefined,
      apartmentNumber: undefined,
      postalCode: undefined,
    },
  };

  @observable
  isLoading = false;

  constructor() {
    makeObservable(this);
  }

  loadCustomer(customerId: number | undefined) {
    if (!customerId) return;
    Api.Customer.apiCustomerGetIdGet({
      id: customerId,
    })
      .then((res) => {
        if (res.content) {
          runInAction(() => {
            this.item = {
              ...res.content,
            };
          });
        } else {
          showNotFoundToast();
          setTimeout(() => redirectTo(AppRoutePaths.customers.url), 1000);
        }
      })
      .catch(showCommunicationError);
  }

  @action
  saveItem(newItem: CustomerDto) {
    this.item = newItem ?? this.item;
  }

  @action
  save(payload: CustomerDto): void {
    this.item = payload;
    this.item.customerId ? this.updateCustomer() : this.addCustomer();
  }

  @action
  addCustomer(): void {
    this.isLoading = true;
    Api.Customer.apiCustomerAddPost({
      customerRequest: {
        ...this.item,
        applicationUserId: appState.user?.id,
      },
    })
      .then(() => {
        showSuccess(t('Customer added'));
        setTimeout(() => redirectTo(AppRoutePaths.customers.url), 1000);
      })
      .catch(showCommunicationError)
      .finally(() => (this.isLoading = false));
  }

  @action
  updateCustomer(): void {
    this.isLoading = true;
    Api.Customer.apiCustomerUpdatePut({
      customerRequest: {
        ...this.item,
      },
    })
      .then(() => {
        showSuccess(t('Changes saved'));
        setTimeout(() => redirectTo(AppRoutePaths.customers.url), 1000);
      })
      .catch(showCommunicationError)
      .finally(() => (this.isLoading = false));
  }

  @action
  deleteCustomer() {
    if (!this.item.customerId) return;

    this.isLoading = true;
    Api.Customer.apiCustomerDeleteIdDelete({
      id: this.item.customerId,
    })
      .then(() => {
        showSuccess(t('Customer deleted'));
        setTimeout(() => redirectTo(AppRoutePaths.customers.url), 1000);
      })
      .catch(showCommunicationError)
      .finally(() => (this.isLoading = false));
  }
}
